import React, { useState } from 'react';
import styles from './PlayerConnectControl.module.scss';
import ConnectInfoModal from './ConnectInfoModal';

function PlayerConnectControl({ connectEnabled, mirrorCount, room }) {
    const [showInfo, setShowInfo] = useState(false);
    const [showDisableConfirm, setShowDisableConfirm] = useState(false);

    const handleToggle = () => {
        if (connectEnabled) {
            if (mirrorCount > 0) {
                setShowDisableConfirm(true);
                return;
            }
            sendToggle(false);
        } else {
            sendToggle(true);
        }
    };

    const sendToggle = (enabled) => {
        if (room) room.send("player_set_connect_enabled", { enabled });
    };

    const confirmDisable = () => {
        sendToggle(false);
        setShowDisableConfirm(false);
    };

    const countText = mirrorCount === 0
        ? "No screens connected"
        : `${mirrorCount} screen${mirrorCount !== 1 ? 's' : ''} connected`;

    return (
        <div className={`${styles.bar} ${!connectEnabled ? styles.disabled : ''}`}>
            <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
            </svg>

            <div className={styles.textWrap}>
                <div className={styles.label}>Connect</div>
                <div className={styles.count}>{connectEnabled ? countText : "Disabled"}</div>
            </div>

            <label className={styles.toggleWrapper} title={connectEnabled ? "Disable Connect" : "Enable Connect"}>
                <input
                    type="checkbox"
                    checked={connectEnabled}
                    onChange={handleToggle}
                    className={styles.toggleInput}
                />
                <span className={styles.toggleSlider}></span>
            </label>

            <button
                type="button"
                className={styles.infoButton}
                onClick={() => setShowInfo(true)}
                aria-label="What is Connect?"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
            </button>

            <ConnectInfoModal show={showInfo} onHide={() => setShowInfo(false)} />

            {showDisableConfirm && (
                <div className={styles.confirmBackdrop} onClick={() => setShowDisableConfirm(false)}>
                    <div className={styles.confirmBox} onClick={(e) => e.stopPropagation()}>
                        <h4>Disable Connect?</h4>
                        <p>{mirrorCount} {mirrorCount === 1 ? "screen is" : "screens are"} currently connected. Disabling will disconnect {mirrorCount === 1 ? "it" : "them"}.</p>
                        <div className={styles.confirmButtons}>
                            <button className={`${styles.confirmBtn} ${styles.confirmBtnSecondary}`} onClick={() => setShowDisableConfirm(false)}>Cancel</button>
                            <button className={`${styles.confirmBtn} ${styles.confirmBtnDanger}`} onClick={confirmDisable}>Disable</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PlayerConnectControl;
